var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { "padding-bottom": "50px", background: "#f4f5f7" },
    },
    [
      _c(
        "BjSteps",
        {
          attrs: {
            active: "4",
            title: _vm.$t("workOrderList.Submit"),
            defaultOptions: [
              _vm.$t("workOrderList.step1"),
              _vm.$t("workOrderList.step2"),
              _vm.$t("workOrderList.step3"),
              _vm.$t("workOrderList.step4"),
            ],
          },
        },
        [
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              _vm.$route.query.type != "add"
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.showLog } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessPurchaseApplyDetail.operationLog")
                        )
                      ),
                    ]
                  )
                : _vm._e(),
              ["add", "edit"].includes(_vm.$route.query.type)
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  )
                : _vm._e(),
              _vm.$route.query.type == "add"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(_vm._s(_vm.$t("submitText")))]
                  )
                : _vm._e(),
              _vm.$route.query.type == "audit"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmitChoose },
                    },
                    [_vm._v(_vm._s(_vm.$t("submitText")))]
                  )
                : _vm._e(),
              _vm.$route.query.type == "completed"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleFinish },
                    },
                    [_vm._v(_vm._s(_vm.$t("submitText")))]
                  )
                : _vm._e(),
              _vm.$route.query.type == "hoursDone"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.ConfirmTime },
                    },
                    [_vm._v(_vm._s(_vm.$t("submitText")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-position": "top",
            rules: _vm.rules,
            "label-width": "160px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-spacebetween profit-top" },
            [
              _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("workOrderList.TicketInformation"))),
              ]),
              _c(
                "div",
                { staticClass: "profit-topLeft" },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: (_vm.colSpan / 3) * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.CustomerName"),
                                prop: "cusId",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  "option-list": _vm.customerList,
                                  disabled:
                                    [
                                      "view",
                                      "audit",
                                      "completed",
                                      "hoursDone",
                                    ].includes(_vm.$route.query.type) ||
                                    _vm.$store.getters.cusId,
                                  placeholder: _vm.$t("customerNameText"),
                                },
                                on: { change: _vm.changeCustomer },
                                model: {
                                  value: _vm.form.cusId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cusId", $$v)
                                  },
                                  expression: "form.cusId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: (_vm.colSpan / 3) * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("workOrderList.Customer"),
                                prop: "customer",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.form.customer,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "customer", $$v)
                                  },
                                  expression: "form.customer",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: (_vm.colSpan / 3) * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("workOrderList.Number"),
                                prop: "workNo",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.form.workNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "workNo", $$v)
                                  },
                                  expression: "form.workNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: (_vm.colSpan / 3) * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "WorkorderType.table.InquiryType"
                                ),
                                prop: "consultType",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  disabled: [
                                    "view",
                                    "audit",
                                    "completed",
                                    "hoursDone",
                                  ].includes(_vm.$route.query.type),
                                  "option-list": _vm.consultNameTopList,
                                },
                                on: { change: _vm.getNextList },
                                model: {
                                  value: _vm.form.consultType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "consultType", $$v)
                                  },
                                  expression: "form.consultType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: (_vm.colSpan / 3) * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("workOrderList.service"),
                                prop: "workOrderTypeId",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  disabled:
                                    [
                                      "view",
                                      "audit",
                                      "completed",
                                      "hoursDone",
                                    ].includes(_vm.$route.query.type) ||
                                    !_vm.form.consultType,
                                  "option-list": _vm.workOrderTypeIdList,
                                },
                                model: {
                                  value: _vm.form.workOrderTypeId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "workOrderTypeId", $$v)
                                  },
                                  expression: "form.workOrderTypeId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: (_vm.colSpan / 3) * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("workOrderList.typeTitle"),
                                prop: "relevance",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  disabled: !["add", "edit"].includes(
                                    _vm.$route.query.type
                                  ),
                                  "option-list": _vm.skuOrderPoList,
                                  clearable: false,
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.form.workOrderSpoVOList = []
                                  },
                                },
                                model: {
                                  value: _vm.form.relevance,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "relevance", $$v)
                                  },
                                  expression: "form.relevance",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan * 2 } },
                        [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "bj-form-title",
                                staticStyle: {
                                  float: "left",
                                  "line-height": "2",
                                  "margin-top": "10px",
                                  "font-size": "14px",
                                  "font-weight": "700",
                                  color: "#606266",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("workOrderList.typeTitle")) +
                                    ":"
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  float: "right",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.SELECTED_BJ_EBC_ID.length == 0 ||
                                        !["add", "edit"].includes(
                                          _vm.$route.query.type
                                        ),
                                      type: "danger",
                                    },
                                    on: { click: _vm.onBatchDelete },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("goodsSku.package.delete"))
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled:
                                        !["add", "edit"].includes(
                                          _vm.$route.query.type
                                        ) ||
                                        ![1, 2, 3].includes(_vm.form.relevance),
                                      type: "primary",
                                    },
                                    on: { click: _vm.openSelectForm },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("addText")))]
                                ),
                              ],
                              1
                            ),
                          ]),
                          [1, 2, 3].includes(_vm.form.relevance)
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.form.workOrderSpoVOList,
                                    stripe: "",
                                    border: "",
                                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                                  },
                                  on: {
                                    "selection-change":
                                      _vm.handleSelectionChange,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "selection",
                                      width: "55",
                                      align: "center",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: _vm.$t(
                                        "DetailsOfThirdPartySalesOrder.Serial"
                                      ),
                                      align: "center",
                                      width: "60",
                                    },
                                  }),
                                  _vm.form.relevance == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "skuName",
                                          label: _vm.$t(
                                            "ExternalOrders.newAdd.ProductName"
                                          ),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "standardSkuCode",
                                          label: _vm.$t(
                                            "SalesOrderToBeApproved.SKU"
                                          ),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "barCode",
                                          label: _vm.$t("workOrderList.bar"),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 1
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "quantity",
                                          label: _vm.$t(
                                            "DetailsOfThirdPartySalesOrder.Quantity"
                                          ),
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return _vm.form.relevance == 1
                                                  ? [
                                                      _c("BjInputNumber", {
                                                        attrs: {
                                                          disabled: ![
                                                            "add",
                                                            "edit",
                                                          ].includes(
                                                            _vm.$route.query
                                                              .type
                                                          ),
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.quantity,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "quantity",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.quantity",
                                                        },
                                                      }),
                                                    ]
                                                  : undefined
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "code",
                                          label: _vm.$t("billingPage.code"),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "shippingMethod",
                                          label: _vm.$t(
                                            "BusinessPurchaseOrder2.means"
                                          ),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "containerId",
                                          label: _vm.$t(
                                            "BusinessPurchaseOrder2.form.containerId"
                                          ),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "status",
                                          label: _vm.$t("table.statusText"),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 3
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "webReference",
                                          label: _vm.$t(
                                            "InternalSalesOrderDetails.party"
                                          ),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 3
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "sapOrderNo",
                                          label: _vm.$t(
                                            "InternalOrder.form.wmsOrderNo"
                                          ),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.relevance == 3
                                    ? _c("el-table-column", {
                                        attrs: {
                                          prop: "totalOrderStatus",
                                          label: _vm.$t("orderNewPatch.Status"),
                                          "show-overflow-tooltip": "",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(
                                                            scope.row
                                                              .totalOrderStatus
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          606179034
                                        ),
                                      })
                                    : _vm._e(),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "BusinessThirdOrderAdd.form.Operation"
                                      ),
                                      align: "center",
                                      fixed: "right",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    disabled: ![
                                                      "add",
                                                      "edit",
                                                    ].includes(
                                                      _vm.$route.query.type
                                                    ),
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDelete(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("delText"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1908587098
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: _vm.colSpan * 2 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex flex-spacebetween",
                            staticStyle: { "margin-top": "10px" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "profit-fileLeft" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("workOrderList.enclosure"),
                                      prop: "accessories",
                                    },
                                  },
                                  [
                                    _c(
                                      "UploadFile",
                                      {
                                        ref: "UploadAccessoriesFileRef",
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          limit: 20,
                                          "limit-size": 5 * 1024,
                                          multiple: "",
                                          accept:
                                            "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx,txt",
                                          "accept-list": [
                                            "image/jpeg",
                                            "image/png",
                                            ".csv",
                                            ".pdf",
                                            ".doc",
                                            ".docx",
                                            ".xlsx",
                                            "txt",
                                          ],
                                          "auto-upload": "",
                                          "limit-hide": "",
                                        },
                                        on: {
                                          handleFileListChange: _vm.fileChange,
                                        },
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "default" },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  disabled: [
                                                    "view",
                                                    "audit",
                                                    "completed",
                                                    "hoursDone",
                                                  ].includes(
                                                    _vm.$route.query.type
                                                  ),
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessImportHistory.page.SelectFile"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "profit-fileRight" },
                              [
                                _vm.accessoriesArr.length > 0
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "file",
                                          staticStyle: {
                                            "line-height": "1.5",
                                            "font-weight": "500",
                                            "font-size": "14px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fileUpload" },
                                            _vm._l(
                                              _vm.accessoriesArr,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "flex-align flex-spacebetween",
                                                    staticStyle: {
                                                      color: "#3173d0",
                                                      cursor: "pointer",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "flex" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "File" +
                                                              _vm._s(
                                                                index + 1
                                                              ) +
                                                              ":"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ellipsis",
                                                            staticStyle: {
                                                              width: "200px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mr20",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex-align flex-spacebetween",
                                                      },
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "edit-btn",
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                              "margin-right":
                                                                "10px",
                                                            },
                                                            attrs: {
                                                              size: "mini",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downloadImageUrl(
                                                                  item.url,
                                                                  item.name
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "downloadText"
                                                                )
                                                              )
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-download el-icon--right",
                                                            }),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "delete-btn",
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                              "margin-right":
                                                                "10px",
                                                            },
                                                            attrs: {
                                                              size: "mini",
                                                              disabled:
                                                                _vm.$route.query
                                                                  .type ==
                                                                "view",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.delImg(
                                                                  "accessoriesArr",
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "delText"
                                                                )
                                                              )
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-delete red el-icon--right",
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "profit-topRight" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("workOrderList.Work"),
                          prop: "remark",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            disabled: [
                              "view",
                              "audit",
                              "completed",
                              "hoursDone",
                            ].includes(_vm.$route.query.type),
                            maxlength: _vm.MAX_LENGTH.MAX,
                            type: "textarea",
                            rows: 20,
                            "show-word-limit": "",
                            autosize: "",
                          },
                          model: {
                            value: _vm.form.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "remark", $$v)
                            },
                            expression: "form.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          !_vm.$store.getters.cusId
            ? _c("div", { staticClass: "flex flex-spacebetween" }, [
                [3, 4, 5, 6, 7, 9].includes(this.form.status) ||
                (_vm.$route.query.type == "audit" && this.form.status == 2)
                  ? _c(
                      "div",
                      { staticClass: "profit-left" },
                      [
                        _c("BjDivider", [
                          _vm._v(_vm._s(_vm.$t("workOrderList.auditTitle"))),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("workOrderList.findings"),
                                      prop: "chooseAudit",
                                    },
                                  },
                                  [
                                    _c("BjSelectLov", {
                                      attrs: {
                                        disabled: this.form.status != 2,
                                        "option-list":
                                          _vm.CSG_WORK_ORDER_REVIEW,
                                      },
                                      model: {
                                        value: _vm.chooseAudit,
                                        callback: function ($$v) {
                                          _vm.chooseAudit = $$v
                                        },
                                        expression: "chooseAudit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.chooseAudit == "0"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("workOrderList.Urgent"),
                                          prop: "exigency",
                                        },
                                      },
                                      [
                                        _c("BjSelectLov", {
                                          attrs: {
                                            disabled: this.form.status != 2,
                                            "option-list":
                                              _vm.CSG_WORK_ORDER_EXIGENCY,
                                          },
                                          model: {
                                            value: _vm.form.exigency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "exigency",
                                                $$v
                                              )
                                            },
                                            expression: "form.exigency",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.chooseAudit == "0"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "workOrderList.Processing"
                                          ),
                                          prop: "userName",
                                        },
                                      },
                                      [
                                        _c("BjSelectLov", {
                                          attrs: {
                                            disabled: this.form.status != 2,
                                            "option-list": _vm.userRoleList,
                                          },
                                          on: { change: _vm.chooseAuditUser },
                                          model: {
                                            value: _vm.form.userName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "userName",
                                                $$v
                                              )
                                            },
                                            expression: "form.userName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.chooseAudit == "0"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 9 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "workOrderList.CompletionTime"
                                          ),
                                          prop: "auditTime",
                                        },
                                      },
                                      [
                                        _c("BjDateTimerangePicker", {
                                          attrs: {
                                            disabled: this.form.status != 2,
                                            "picker-options": _vm.pickerOptions,
                                            placeholder: _vm.$t(
                                              "workOrderList.Completion"
                                            ),
                                          },
                                          model: {
                                            value: _vm.queryParams_endTime,
                                            callback: function ($$v) {
                                              _vm.queryParams_endTime = $$v
                                            },
                                            expression: "queryParams_endTime",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.chooseAudit == "1"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 19 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("workOrderList.Reason"),
                                          prop: "reason",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: this.form.status != 2,
                                            maxlength: _vm.MAX_LENGTH.MAX,
                                            type: "textarea",
                                            "show-word-limit": "",
                                            autosize: "",
                                          },
                                          model: {
                                            value: _vm.form.reason,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "reason", $$v)
                                            },
                                            expression: "form.reason",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.chooseAudit == "2"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 9 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "workOrderList.DepartmentText"
                                          ),
                                          prop: "consultName",
                                        },
                                      },
                                      [
                                        _c("BjSelectLov", {
                                          attrs: {
                                            disabled: this.form.status != 2,
                                            "option-list": _vm.consultNameList,
                                          },
                                          on: { change: _vm.getSection },
                                          model: {
                                            value: _vm.form.consultName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "consultName",
                                                $$v
                                              )
                                            },
                                            expression: "form.consultName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.chooseAudit == "2"
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 10 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "workOrderList.service"
                                          ),
                                          prop: "workOrderTypeBottomId",
                                        },
                                      },
                                      [
                                        _c("BjSelectLov", {
                                          attrs: {
                                            disabled:
                                              this.form.status != 2 ||
                                              !_vm.form.consultName,
                                            "option-list":
                                              _vm.workOrderTypeIdBottomList,
                                          },
                                          model: {
                                            value:
                                              _vm.form.workOrderTypeBottomId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "workOrderTypeBottomId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.workOrderTypeBottomId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        (["view", "hoursDone"].includes(
                          _vm.$route.query.type
                        ) &&
                          [5, 9].includes(this.form.status)) ||
                        (_vm.$route.query.type == "completed" &&
                          this.form.status == 4)
                          ? _c("BjDivider", [
                              _vm._v(_vm._s(_vm.$t("workOrderList.results"))),
                            ])
                          : _vm._e(),
                        (["view", "hoursDone"].includes(
                          _vm.$route.query.type
                        ) &&
                          [5, 9].includes(this.form.status)) ||
                        (_vm.$route.query.type == "completed" &&
                          this.form.status == 4)
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: _vm.colSpan } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "workOrderList.results"
                                          ),
                                          prop: "handleResult",
                                        },
                                      },
                                      [
                                        _c("BjSelectLov", {
                                          attrs: {
                                            disabled:
                                              _vm.$route.query.type == "view",
                                            "option-list":
                                              _vm.CSG_WORK_ORDER_HANDLERESULT,
                                          },
                                          model: {
                                            value: _vm.form.handleResult,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "handleResult",
                                                $$v
                                              )
                                            },
                                            expression: "form.handleResult",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                (["view", "hoursDone"].includes(
                                  _vm.$route.query.type
                                ) &&
                                  [5, 9].includes(this.form.status)) ||
                                (_vm.$route.query.type == "completed" &&
                                  this.form.status == 4)
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: _vm.colSpan } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "workOrderList.Total"
                                              ),
                                              prop: "workingTime",
                                            },
                                          },
                                          [
                                            _c("BjInput", {
                                              attrs: {
                                                disabled:
                                                  _vm.$route.query.type ==
                                                  "view",
                                                maxlength:
                                                  _vm.MAX_LENGTH.DEFAULT,
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: _vm.form.workingTime,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "workingTime",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.workingTime",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-col",
                                  { attrs: { span: _vm.colSpan * 2 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("workOrderList.Ticket"),
                                          prop: "handleResultOther",
                                        },
                                      },
                                      [
                                        _c("BjInput", {
                                          attrs: {
                                            disabled:
                                              _vm.$route.query.type == "view",
                                            maxlength: _vm.MAX_LENGTH.MAX,
                                            type: "textarea",
                                            rows: 5,
                                            "show-word-limit": "",
                                            autosize: "",
                                          },
                                          model: {
                                            value: _vm.form.handleResultOther,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "handleResultOther",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.handleResultOther",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: _vm.colSpan * 2 } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-spacebetween" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "profit-fileLeft" },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "workOrderList.enclosure"
                                                  ),
                                                  prop: "accessoriesList.adder",
                                                },
                                              },
                                              [
                                                _c(
                                                  "UploadFile",
                                                  {
                                                    ref: "UploadFileRef",
                                                    staticClass:
                                                      "avatar-uploader",
                                                    attrs: {
                                                      limit: 20,
                                                      "limit-size": 5 * 1024,
                                                      multiple: "",
                                                      accept:
                                                        "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx,txt",
                                                      "accept-list": [
                                                        "image/jpeg",
                                                        "image/png",
                                                        ".csv",
                                                        ".pdf",
                                                        ".doc",
                                                        ".docx",
                                                        ".xlsx",
                                                        "txt",
                                                      ],
                                                      "auto-upload": "",
                                                      "limit-hide": "",
                                                    },
                                                    on: {
                                                      handleFileListChange:
                                                        _vm.fileListChange,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "default" },
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.$route.query
                                                                  .type ==
                                                                "view",
                                                              size: "small",
                                                              type: "primary",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BusinessImportHistory.page.SelectFile"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "profit-fileRight" },
                                          [
                                            _vm.fileList.length > 0
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "file",
                                                      staticStyle: {
                                                        "line-height": "1.5",
                                                        "font-weight": "500",
                                                        "font-size": "14px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fileUpload",
                                                        },
                                                        _vm._l(
                                                          _vm.fileList,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "flex-align flex-spacebetween",
                                                                staticStyle: {
                                                                  color:
                                                                    "#3173d0",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "flex",
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "File" +
                                                                          _vm._s(
                                                                            index +
                                                                              1
                                                                          ) +
                                                                          ":"
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ellipsis",
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "200px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "mr20",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.name
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "flex-align flex-spacebetween",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-button",
                                                                      {
                                                                        staticClass:
                                                                          "edit-btn",
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "12px",
                                                                            "margin-right":
                                                                              "10px",
                                                                          },
                                                                        attrs: {
                                                                          size: "mini",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.downloadImageUrl(
                                                                                item.url,
                                                                                item.name
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "downloadText"
                                                                            )
                                                                          )
                                                                        ),
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-download el-icon--right",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "el-button",
                                                                      {
                                                                        staticClass:
                                                                          "delete-btn",
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "12px",
                                                                            "margin-right":
                                                                              "10px",
                                                                          },
                                                                        attrs: {
                                                                          size: "mini",
                                                                          disabled:
                                                                            _vm
                                                                              .$route
                                                                              .query
                                                                              .type ==
                                                                            "view",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.delImg(
                                                                                "fileList",
                                                                                index
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "delText"
                                                                            )
                                                                          )
                                                                        ),
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-delete red el-icon--right",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                ["view", "hoursDone"].includes(_vm.$route.query.type) &&
                [5, 9].includes(this.form.status)
                  ? _c(
                      "div",
                      { staticClass: "profit-right" },
                      [
                        _c("BjDivider", [
                          _vm._v(_vm._s(_vm.$t("workOrderList.customerTitle"))),
                        ]),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "-10px" } },
                          [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "bj-form-title",
                                  staticStyle: {
                                    float: "left",
                                    "line-height": "2",
                                    "margin-top": "10px",
                                    "font-size": "14px",
                                    "font-weight": "700",
                                    color: "#606266",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("workOrderList.Fee")) + ":"
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    float: "right",
                                    "margin-bottom": "10px",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.SELECTED_CHARGE_ID.length == 0 ||
                                          _vm.$route.query.type == "view",
                                        type: "danger",
                                      },
                                      on: { click: _vm.onBatchDelCharge },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("goodsSku.package.delete")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.$route.query.type == "view",
                                        type: "primary",
                                      },
                                      on: { click: _vm.openCharge },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("addText")))]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: _vm.form.workOrderChargesVOList,
                                  stripe: "",
                                  border: "",
                                  "header-cell-style": _vm.$rowStyle.DEFAULT,
                                },
                                on: {
                                  "selection-change": _vm.chargeSelectionChange,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    type: "selection",
                                    width: "55",
                                    align: "center",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    type: "index",
                                    label: _vm.$t(
                                      "DetailsOfThirdPartySalesOrder.Serial"
                                    ),
                                    align: "center",
                                    width: "60",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "tag",
                                    label: _vm.$t("billingPage.tag"),
                                    "show-overflow-tooltip": "",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.tag == "Ticket1"
                                                    ? _vm.$t(
                                                        "billingPage.timePay"
                                                      )
                                                    : scope.row.tag == "Ticket2"
                                                    ? _vm.$t(
                                                        "billingPage.quantityPay"
                                                      )
                                                    : scope.row.tag
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3014656889
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "pay",
                                    label: _vm.$t("billingPage.Category"),
                                    "show-overflow-tooltip": "",
                                    align: "center",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "number",
                                    label: _vm.$t("billingPage.quantity"),
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("BjInputNumber", {
                                              attrs: {
                                                disabled:
                                                  _vm.$route.query.type ==
                                                    "view" ||
                                                  scope.row.tag != "Ticket2",
                                              },
                                              model: {
                                                value: scope.row.number,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "number",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.number",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1158489797
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "duration",
                                    label: _vm.$t("workOrderList.Total"),
                                    "show-overflow-tooltip": "",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("BjInputNumber", {
                                              attrs: {
                                                disabled:
                                                  _vm.$route.query.type ==
                                                    "view" ||
                                                  scope.row.tag != "Ticket1",
                                              },
                                              model: {
                                                value: scope.row.duration,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "duration",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.duration",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1022431291
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "BusinessThirdOrderAdd.form.Operation"
                                    ),
                                    align: "center",
                                    fixed: "right",
                                    width: "120",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.$route.query.type ==
                                                    "view",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDelCharge(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("delText"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2838347375
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        ["view", "hoursDone"].includes(_vm.$route.query.type) &&
                        [5, 9].includes(this.form.status)
                          ? _c(
                              "div",
                              { staticStyle: { "padding-top": "15px" } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t("workOrderList.Comments") + ":",
                                      prop: "remarks",
                                    },
                                  },
                                  [
                                    _c("BjInput", {
                                      attrs: {
                                        disabled:
                                          _vm.$route.query.type == "view",
                                        maxlength: _vm.MAX_LENGTH.MAX,
                                        type: "textarea",
                                        rows: 5,
                                        "show-word-limit": "",
                                        autosize: "",
                                      },
                                      model: {
                                        value: _vm.form.remarks,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "remarks", $$v)
                                        },
                                        expression: "form.remarks",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                [2, 3, 4, 5, 6, 7, 9].includes(this.form.status)
                  ? _c(
                      "div",
                      { staticClass: "profit-right" },
                      [
                        _c(
                          "BjDivider",
                          [
                            _vm._v(
                              _vm._s(_vm.$t("billingPage.InternalNotes")) + " "
                            ),
                            _vm.$route.query.type == "view"
                              ? _c(
                                  "template",
                                  { slot: "right" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.openNotesDialog },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "billingPage.addInternalNotes"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              "max-height": "500px",
                            },
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              _vm._l(
                                _vm.form.workOrderRemarkVoList,
                                function (item, index) {
                                  return _c(
                                    "el-col",
                                    {
                                      key: index,
                                      attrs: { span: _vm.colSpan * 2 },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label:
                                              item.user +
                                              "  " +
                                              _vm.timeOperateTwoHour(
                                                item.createTime
                                              ),
                                            prop: "message",
                                          },
                                        },
                                        [
                                          _c("BjWangEditor", {
                                            attrs: {
                                              disabled: "",
                                              "show-toolbar": false,
                                              "min-height": 90,
                                            },
                                            model: {
                                              value: item.message,
                                              callback: function ($$v) {
                                                _vm.$set(item, "message", $$v)
                                              },
                                              expression: "item.message",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                [2, 3, 4, 5, 6, 7, 9].includes(this.form.status)
                  ? _c(
                      "div",
                      { staticClass: "profit-right" },
                      [
                        _c(
                          "BjDivider",
                          [
                            _vm._v(
                              _vm._s(_vm.$t("billingPage.messages")) + " "
                            ),
                            _c(
                              "template",
                              { slot: "right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.openMessagesDialog },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("billingPage.addmessages"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              "max-height": "500px",
                            },
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              _vm._l(
                                _vm.form.workOrderMessageVoList,
                                function (item, index) {
                                  return _c(
                                    "el-col",
                                    {
                                      key: index,
                                      attrs: { span: _vm.colSpan * 2 },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label:
                                              item.user +
                                              "  " +
                                              _vm.timeOperateTwoHour(
                                                item.createTime
                                              ),
                                            prop: "message",
                                          },
                                        },
                                        [
                                          _c("BjWangEditor", {
                                            attrs: {
                                              disabled: "",
                                              "show-toolbar": false,
                                              "min-height": 90,
                                            },
                                            model: {
                                              value: item.message,
                                              callback: function ($$v) {
                                                _vm.$set(item, "message", $$v)
                                              },
                                              expression: "item.message",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.$store.getters.cusId
            ? _c("div", { staticClass: "flex flex-spacebetween" }, [
                (["view", "hoursDone"].includes(_vm.$route.query.type) &&
                  [5, 9].includes(this.form.status)) ||
                (_vm.$route.query.type == "completed" && this.form.status == 4)
                  ? _c(
                      "div",
                      { staticClass: "profit-left" },
                      [
                        _c("BjDivider", [
                          _vm._v(_vm._s(_vm.$t("workOrderList.results"))),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: (_vm.colSpan * 2) / 3 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("workOrderList.results"),
                                      prop: "handleResult",
                                    },
                                  },
                                  [
                                    _c("BjSelectLov", {
                                      attrs: {
                                        disabled:
                                          _vm.$route.query.type == "view",
                                        "option-list":
                                          _vm.CSG_WORK_ORDER_HANDLERESULT,
                                      },
                                      model: {
                                        value: _vm.form.handleResult,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "handleResult",
                                            $$v
                                          )
                                        },
                                        expression: "form.handleResult",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: ((_vm.colSpan * 2) / 3) * 2 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("workOrderList.Ticket"),
                                      prop: "handleResultOther",
                                    },
                                  },
                                  [
                                    _c("BjInput", {
                                      attrs: {
                                        disabled:
                                          _vm.$route.query.type == "view",
                                        maxlength: _vm.MAX_LENGTH.MAX,
                                        type: "textarea",
                                        rows: 5,
                                        "show-word-limit": "",
                                        autosize: "",
                                      },
                                      model: {
                                        value: _vm.form.handleResultOther,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "handleResultOther",
                                            $$v
                                          )
                                        },
                                        expression: "form.handleResultOther",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "margin-top": "20px" },
                                attrs: { span: _vm.colSpan * 2 },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-spacebetween" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "profit-fileLeft" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "workOrderList.enclosure"
                                              ),
                                              prop: "accessoriesList.adder",
                                            },
                                          },
                                          [
                                            _c(
                                              "UploadFile",
                                              {
                                                ref: "UploadFileRef",
                                                staticClass: "avatar-uploader",
                                                attrs: {
                                                  limit: 20,
                                                  "limit-size": 5 * 1024,
                                                  multiple: "",
                                                  accept:
                                                    "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx,txt",
                                                  "accept-list": [
                                                    "image/jpeg",
                                                    "image/png",
                                                    ".csv",
                                                    ".pdf",
                                                    ".doc",
                                                    ".docx",
                                                    ".xlsx",
                                                    "txt",
                                                  ],
                                                  "auto-upload": "",
                                                  "limit-hide": "",
                                                },
                                                on: {
                                                  handleFileListChange:
                                                    _vm.fileListChange,
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "default" },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.$route.query
                                                              .type == "view",
                                                          size: "small",
                                                          type: "primary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BusinessImportHistory.page.SelectFile"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "profit-fileRight" },
                                      [
                                        _vm.fileList.length > 0
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "file",
                                                  staticStyle: {
                                                    "line-height": "1.5",
                                                    "font-weight": "500",
                                                    "font-size": "14px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "fileUpload",
                                                    },
                                                    _vm._l(
                                                      _vm.fileList,
                                                      function (item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "flex-align flex-spacebetween",
                                                            staticStyle: {
                                                              color: "#3173d0",
                                                              cursor: "pointer",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "File" +
                                                                      _vm._s(
                                                                        index +
                                                                          1
                                                                      ) +
                                                                      ":"
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "ellipsis",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "200px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "mr20",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex-align flex-spacebetween",
                                                              },
                                                              [
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    staticClass:
                                                                      "edit-btn",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "12px",
                                                                        "margin-right":
                                                                          "10px",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.downloadImageUrl(
                                                                            item.url,
                                                                            item.name
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "downloadText"
                                                                        )
                                                                      )
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-download el-icon--right",
                                                                    }),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    staticClass:
                                                                      "delete-btn",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "12px",
                                                                        "margin-right":
                                                                          "10px",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                      disabled:
                                                                        _vm
                                                                          .$route
                                                                          .query
                                                                          .type ==
                                                                        "view",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.delImg(
                                                                            "fileList",
                                                                            index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "delText"
                                                                        )
                                                                      )
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-delete red el-icon--right",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                [2, 3, 4, 5, 6, 7, 9].includes(this.form.status)
                  ? _c(
                      "div",
                      { staticClass: "profit-right" },
                      [
                        _c(
                          "BjDivider",
                          [
                            _vm._v(
                              _vm._s(_vm.$t("billingPage.messages")) + " "
                            ),
                            _c(
                              "template",
                              { slot: "right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.openMessagesDialog },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("billingPage.addmessages"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              "max-height": "500px",
                            },
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              _vm._l(
                                _vm.form.workOrderMessageVoList,
                                function (item, index) {
                                  return _c(
                                    "el-col",
                                    {
                                      key: index,
                                      attrs: { span: _vm.colSpan * 2 },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label:
                                              item.user +
                                              "  " +
                                              _vm.timeOperateTwoHour(
                                                item.createTime
                                              ),
                                            prop: "message",
                                          },
                                        },
                                        [
                                          _c("BjWangEditor", {
                                            attrs: {
                                              disabled: "",
                                              "show-toolbar": false,
                                              "min-height": 90,
                                            },
                                            model: {
                                              value: item.message,
                                              callback: function ($$v) {
                                                _vm.$set(item, "message", $$v)
                                              },
                                              expression: "item.message",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "BjDialog",
        {
          attrs: {
            title: _vm.$t("billingPage.addInternalNotes"),
            visible: _vm.notesVisible,
            width: "640px",
            "destroy-on-close": "",
          },
          on: {
            close: function ($event) {
              return _vm.clearVisibleLeft()
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "commentForm",
              attrs: {
                model: _vm.commentForm,
                rules: _vm.commentFormRules,
                "label-width": "100px",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.Comments"),
                    prop: "comment",
                  },
                },
                [
                  _c("BjWangEditor", {
                    attrs: {
                      placeholder: _vm.$t("billingPage.Comments"),
                      "min-height": 180,
                    },
                    on: { blur: _vm.validateNotesComment },
                    model: {
                      value: _vm.commentForm.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.commentForm, "comment", $$v)
                      },
                      expression: "commentForm.comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.clearVisibleLeft()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNotes } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDialog",
        {
          attrs: {
            title: _vm.$t("billingPage.addmessages"),
            visible: _vm.messagesVisible,
            width: "640px",
            "destroy-on-close": "",
          },
          on: {
            close: function ($event) {
              return _vm.clearVisibleRight()
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "messagesForm",
              attrs: {
                model: _vm.messagesForm,
                rules: _vm.messagesFormRules,
                "label-width": "100px",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.Comments"),
                    prop: "comment",
                  },
                },
                [
                  _c("BjWangEditor", {
                    attrs: {
                      placeholder: _vm.$t("billingPage.Comments"),
                      "min-height": 180,
                    },
                    on: { blur: _vm.validateMessagesComment },
                    model: {
                      value: _vm.messagesForm.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.messagesForm, "comment", $$v)
                      },
                      expression: "messagesForm.comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.clearVisibleRight()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addMessages } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogListOrdinarySku",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.skuDefault(
            _vm.$t("SalesOrderEntry.goods"),
            {
              defaultQuery: {
                cusId: _vm.form.cusId,
                setFlag: 0,
                status: [3, 4, 5],
              },
            }
          ),
          multiple: "",
        },
        on: { confirm: _vm.onAddGoodsDialogConfirm },
      }),
      _c("diaLogForm", {
        ref: "dialogListPo",
        attrs: {
          width: "80%",
          "search-btn-span": 8,
          config: _vm.$BjDialogListConfig.POSelect("SelectPOText", {
            defaultQuery: {
              cusId: _vm.form.cusId,
              status: [
                "New",
                "Uploaded",
                "Arrived",
                "Receiving",
                "Received",
                "UploadFail",
                "Done",
              ],
            },
          }),
          multiple: "",
        },
        on: { confirm: _vm.onAddPODialogConfirm },
      }),
      _c("diaLogForm", {
        ref: "dialogListOrder",
        attrs: {
          width: "80%",
          "search-btn-span": 12,
          config: _vm.$BjDialogListConfig.OrderSelect("SelectOrderText", {
            defaultQuery: { cusId: _vm.form.cusId },
          }),
          multiple: "",
        },
        on: { confirm: _vm.onAddOrderDialogConfirm },
      }),
      _c("BjDialogList", {
        ref: "dialogListChangeItem",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.chargeItemDefault(
            "route.BusinessBillingCategories",
            {
              defaultQuery: {
                tags: "Ticket1,Ticket2",
                tenantId: _vm.$store.getters.tenantId,
              },
            }
          ),
          resetBtnHide: true,
          searchBtnHide: true,
          multiple: "",
        },
        on: { confirm: _vm.onAddChargeItemConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }